import { getAxiosClient } from "../../axios-client";
import { PricelistAddBody, PricelistAddResponse } from "./types";

const axiosClient = getAxiosClient();
export const pricelistAdd = async (body: PricelistAddBody) => {
  return await axiosClient.ax.post<PricelistAddResponse>(
    "Pricelist/Add",
    body
  );
};
